module.exports = __webpack_public_path__ + "static/media/robVernout.853e6f55.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/robVernout.jpg
// module id = 1383
// module chunks = 1